// components/Events/RenderHealEvent.tsx

import React, { useContext } from 'react';
import { BaseRendererProps } from './eventRenderers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTurnUp } from '@fortawesome/free-solid-svg-icons';
import './HealEvent.css';
import GameAssetsContext from '../../../../../../context/GameAssetContext';
import { getUniversalSourceIcon } from './StatChangeEvent';

const HealEvent: React.FC<BaseRendererProps> = ({ log }) => {
  const { gameWideAssets, championsAssets } = useContext(GameAssetsContext);

  const details = log.details;
  const healingAmount = Math.round(details.actualHealedAmount || 0);
  const theoreticalHealAmount = Math.round(details.theoreticalHealAmount || 0);

  const sourceType = details.sourceType || 'Ability';
  const sourceName = details.source;
  const championName = details.championName;
  const imageState = log.imageState;

  // Prepare the text for healing
  // If actual != theoretical => show "50(80)" else "50"
  const showParenthesis = (healingAmount !== theoreticalHealAmount);
  const healingText = showParenthesis
    ? `${healingAmount} (${theoreticalHealAmount})`
    : `${healingAmount}`;

  // Prepare tooltip text
  const tooltipText = `Actual heal: ${healingAmount}, Theoretical heal: ${theoreticalHealAmount}`;

  // Use the universal image fetching function
  const sourceIcon = getUniversalSourceIcon(
    {
      sourceType: sourceType,
      imageState: imageState,
      sourceName: sourceName,
      championName: championName,
    },
    gameWideAssets,
    championsAssets
  );

  return (
    <div className="heal-event">
      {/* Top line: healing icon and "50(80)" text */}
      <div className="heal-amount-line">
        <div className="stat-icon health-regen-icon" />
        <span className="healing-text" title={tooltipText}>{healingText}</span>
      </div>

      {/* Second line: source icon if available */}
      {sourceIcon && (
        <div className="healing-source-line">
          <FontAwesomeIcon icon={faTurnUp} className="fa-turn-up" />
          {sourceIcon}
        </div>
      )}
    </div>
  );
};

export default HealEvent;
